import * as _ from 'lodash'
import bootbox from 'bootbox'


/**
 * Updates an account in MongoDB
 *
 * @param {object} params
 * @param {boolean} [reload]
 */
export function updateAccount(params: object, reload?: boolean) {
    params['_csrf'] = $("meta[name=_csrf]").attr("content")

    $.ajax({
        url: '/json/accounts/update',
        method: 'POST',
        data: params,
        success: function (response) {  
            if (typeof response['error'] !== 'undefined') {
                console.log(response);
                alert(`Error: ${response['error']} (${response['code']})`)
            }

            if (DEBUG) console.log(response)

            const updateEvent = new Event(`update-account`)
            document.dispatchEvent(updateEvent)
            
            if (reload)
                window.location.reload()
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}



/**
 * Delete an account, the transactions in MongoDB
 *
 * @export
 * @param {object} params
 * @param {boolean} [reload]
 */
export function deleteAccount(params: object, reload?: boolean) {
    params['_csrf'] = $("meta[name=_csrf]").attr("content")

    $.ajax({
        url: '/json/accounts/delete',
        method: 'POST',
        data: params,
        success: function (response) {
            if (typeof response['error'] !== 'undefined') {
                console.log(response);
                alert(`Error: ${response['error']} (${response['code']})`)
            }

            if (DEBUG) console.log(response)

            const deleteEvent = new Event(`delete-account`)
            document.dispatchEvent(deleteEvent)

            if (reload)
                window.location.reload()
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}


export function syncAccountTransactions(accountId: string, reload?: boolean) {
    if (typeof globals.vars.userData.accountsById[accountId] === 'undefined')
        return
    
    let dialog = bootbox.dialog({
        title: `<div class="text-truncate">${globals.vars.userData.accountsById[accountId]['custom_name'] !== '' ? globals.vars.userData.accountsById[accountId]['custom_name'] : globals.vars.userData.accountsById[accountId]['name']}</div>`,
        message: `<p class="text-center mb-0 fs-3"><i class="fas fa-spin fa-cog text-truncate"></i> ${global.i18n.t('accounts.sync_in_progress')}</p>`,
        centerVertical: true,
        closeButton: false
    })
   
    const params = {
        accountId: globals.vars.userData.accountsById[accountId]['accountId'],
        _csrf: $("meta[name=_csrf]").attr("content")
    }

    $.ajax({
        url: '/json/transaction/sync',
        method: 'POST',
        data: params,
        success: function (response) {
            if (DEBUG) console.log(response)

            if (response['error']) {
                helpers.alert(response, null, function(result) {
                    dialog.modal('hide')

                    const syncedEvent = new Event(`sync-${accountId}`)
                    document.dispatchEvent(syncedEvent)
        
                    if (DEBUG) console.log((`Event sent: sync-${accountId}`))
        
                    if (reload)
                        window.location.reload()
                })
            } else {
                dialog.modal('hide')

                const syncedEvent = new Event(`sync-${accountId}`)
                document.dispatchEvent(syncedEvent)

                if (DEBUG) console.log((`Event sent: sync-${accountId}`))

                if (reload)
                    window.location.reload()
            }
        },
        error: function (err) {
            helpers.alert(err)

            alert(JSON.stringify(err))

            const syncedEvent = new Event(`sync-${accountId}`)
            document.dispatchEvent(syncedEvent)

            if (reload)
                window.location.reload()
        }
    })
}



export function updateTransaction(params: object, reload?: boolean) {
    params['_csrf'] = $("meta[name=_csrf]").attr("content")

    $.ajax({
        url: '/json/transaction/update',
        method: 'POST',
        data: params,
        success: function (response) {
            if (typeof response['error'] !== 'undefined') {
                console.log(response);
                alert(`Error: ${response['error']} (${response['code']})`)
            }

            if (DEBUG) console.log(response)

            const updateEvent = new Event(`update-transaction`)
            document.dispatchEvent(updateEvent)
            
            if (reload)
                window.location.reload()
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}


export function updateCategory(params: object, reload?: boolean) {
    params['_csrf'] = $("meta[name=_csrf]").attr("content")

    $.ajax({
        url: '/json/category/update',
        method: 'POST',
        data: params,
        success: function (response) {
            if (typeof response['error'] !== 'undefined') {
                console.log(response);
                alert(`Error: ${response['error']} (${response['code']})`)
            }

            if (DEBUG) console.log(response)

            const updateEvent = new Event(`update-category`)
            document.dispatchEvent(updateEvent)
            
            if (reload)
                window.location.reload()
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}

export function updateProfile(params: object, reload?: boolean) {
    const data = { _csrf: $("meta[name=_csrf]").attr("content") }
    data['item'] = params

    $.ajax({
        url: '/json/update-profile',
        method: 'POST',
        data: data,
        success: function (response) {
            if (typeof response['error'] !== 'undefined') {
                console.log(response);
            }
            if (DEBUG) console.log(response)

            if (reload)
                window.location.reload()
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}